// removed by extract-text-webpack-plugin
module.exports = {"root":"_30mPlr6","list":"_21RFCXm","annualIsActive":"_3WLSvJx","hourlyIsActive":"_1aSTVX-","item":"_3A-v9Ag","link":"_2WVScK2","activeLink":"dGaESsB"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/RefineBar/components/SalaryType/SalaryType.less
 ** module id = 925
 ** module chunks = 0
 **/